import React from 'react';
import { withRouter } from 'react-router';
import { ThemedButton } from './ThemedComponents';
import styled, { css } from 'styled-components';

const ThemedFooterLinkButton = styled(ThemedButton)`
    ${(props) =>
        props.continue &&
        css`
            margin-left: auto;
        `};
    ${(props) =>
        props.footer &&
        css`
            margin-right: 20px;
        `};
`;

const ThemedLinkButton = (props) => {
    const {
        history,
        location,
        match,
        staticContext,
        to,
        onClick,
        // ⬆ filtering out props that `button` doesn't know what to do with.
        ...rest
    } = props;
    return (
        <ThemedFooterLinkButton
            {...rest} // `children` is just another prop!
            onClick={(event) => {
                onClick && onClick(event);
                history.push(to);
            }}
        />
    );
};

export default withRouter(ThemedLinkButton);
